import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseRelatedProduct() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      type: isEmpty(state.type),
      filter: isEmpty(state.filter),
      categoryID: isEmpty(state.categoryID),
      groupID: isEmpty(state.groupID),
      brandID: isEmpty(state.brandID),
    };

    setter(errorState);

    if (errorState.type || errorState.filter) {
      enqueueSnackbar("لطفا محصول را کامل انتخاب کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else if (state.filter == 2 && errorState.brandID) {
      enqueueSnackbar("لطفا برند را انتخاب کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else if (state.filter == 3 && errorState.groupID) {
      enqueueSnackbar("لطفا گروه را انتخاب کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getRelatedProductsList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_RelatedProducts?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getProductTypes = (callback) => {
    MyAxios.get(`Admin_RelatedProducts/Types`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getFilterCount = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_RelatedProducts/Count`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateRelatedProducts = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.put(`Admin_RelatedProducts`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };
  const addRelatedProducts = (state, callback) => {
    // state = removeSomeProps(state);
    let newBody = Object.fromEntries(
      Object.entries(state).filter(([_, v]) => v != undefined)
    );
    const data = new FormData();
    data.append("Content", JSON.stringify(newBody));
    MyAxios.post(`Admin_RelatedProducts`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteRelatedProducts = (state, callback) => {
    let newBody = Object.fromEntries(
      Object.entries(state).filter(([_, v]) => v != undefined)
    );

    const data = new FormData();
    data.append("Content", JSON.stringify(newBody));
    MyAxios.delete(`Admin_RelatedProducts`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const GetProductsByWord = (search, callback) => {
    MyAxios.get(`Admin_NewOrder/GetProductsByWord?w=${search}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const getProductByID = (id, callback) => {
    MyAxios.get(`Admin_Products/${id}`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
            searchText: "",
            scrollTo: undefined,
            forceRefresh: false,
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const ChangeProductRelated = (state, callback) => {
    // state = removeSomeProps(state);
    let newBody = Object.fromEntries(
      Object.entries(state).filter(([_, v]) => v != undefined)
    );
    const data = new FormData();
    data.append("Content", JSON.stringify(newBody));
    MyAxios.post(`Admin_RelatedProducts/Change`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت تغییر یافت", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    validate,
    getRelatedProductsList,
    addRelatedProducts,
    deleteRelatedProducts,
    getFilterCount,
    GetProductsByWord,
    getProductByID,
    ChangeProductRelated,
    getProductTypes,
    updateRelatedProducts,
  };
}
